import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import DatePicker from "@cloudscape-design/components/date-picker";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
	promoBannersAddModalStore, promoBannersEditModalStore,
	tournamentsBannersAddModalStore,
} from "../stores/promoBannersEditModal";
import { MAX_BANNER_BYTES } from "../stores/bannersAddModal";
import { bannersStore, BannersStore } from "../stores/banners";
import DateRangePicker from "@cloudscape-design/components/date-range-picker";
import { promoBannersStore, tournamentsBannersStore } from "../stores/promoBanners";

const isValidBannerFileSize = (file) => Boolean(file) && file.size <= MAX_BANNER_BYTES;

class PromoBannersEditModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			showDeleteModal: false,
			isDeleting: false,
		}
	}
	componentDidUpdate(prevProps) {
		if (!prevProps.promoBannersEditModal.show && this.props.promoBannersEditModal.show) {
			this.resetFormFields();
		}
	}

	addBanner() {
		this.setState({
			loading: true
		});
		const body = {
			oldName: this.props.promoBannersEditModal.oldName,
			name: { text: this.props.promoBannersEditModal.name, type: this.props.promoBannersEditModal.nameType.value },
			description: this.props.promoBannersEditModal.descriptionPrefix !== "" ? { type: this.props.promoBannersEditModal.descriptionType.value, prefix: this.props.promoBannersEditModal.descriptionPrefix, text: this.props.promoBannersEditModal.description  } : { type: this.props.promoBannersEditModal.descriptionType.value, text: this.props.promoBannersEditModal.description  },
			image: this.props.promoBannersEditModal.image,
			limit: this.props.promoBannersEditModal.limit > 0 ? this.props.promoBannersEditModal.limit : false,
			minDeposit: this.props.promoBannersEditModal.minDeposit,
			wager: this.props.promoBannersEditModal.wager,
			gameID: this.props.promoBannersEditModal.gameID > 0 ? this.props.promoBannersEditModal.gameID : false,
			date: Math.floor(new Date(this.props.promoBannersEditModal.from).getTime() / 1000)
		};
		this.props.Interface.request("set", {
			class: "data",
			module: "promoBanners",
			method: "edit"
		}, { ...body }).then((result) => {
			this.setState({
				loading: false
			});
			this.props.Interface.addNoty("Success", "Promo banner was successfully edit");
			this.props.setPromoBannersEditModal({ ...this.props.promoBannersEditModal, show: false });
			this.props.Interface.loadPromoBannerList();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setPromoBanners({ ...this.props.promoBanners, loaded: true, error });

			this.setState({
				loading: false
			});

		})
	}

	deleteBanner(name) {
		this.setState({ isDeleting: true });
		const data = {
			name,
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "promoBanners",
			method: "delete"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Delete " + name.text  + " was success");
			this.setState({ showDeleteModal: false, isDeleting: false });
			this.props.setPromoBannersEditModal({ ...this.props.promoBannersEditModal, show: false });
			this.props.Interface.loadPromoBannerList();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.Interface.addNoty("Error", error.text);
			this.props.setPromoBanners({ ...this.props.promoBanners, loaded: true, error });
			this.setState({ isDeleting: false });
		})
	}

	openDeleteModal = () => {
		if (!this.props.promoBannersEditModal.oldName) return;
		this.setState({ showDeleteModal: true });
	};

	closeDeleteModal = () => {
		if (this.state.isDeleting) return;
		this.setState({ showDeleteModal: false });
	};

	confirmDelete = () => {
		const { oldName } = this.props.promoBannersEditModal;
		if (!oldName) return;
		this.deleteBanner(oldName);
	};

	closeEditModal = () => {
		if (this.state.isDeleting) return;
		this.setState({ showDeleteModal: false });
		this.props.setPromoBannersEditModal({ ...this.props.promoBannersEditModal, show: false });
	};

	resetFormFields = () => {
		this.props.setPromoBannersEditModal({
			...this.props.promoBannersEditModal,
			type: "",
			name: "",
			description: "",
			descriptionType: "",
			descriptionPrefix: "",
			gameID: "",
			minDeposit: "",
			limit: "",
			wager: "",
			date: "",
			image: "",
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
		});
	};

	updateParam = (key, value) => {
		const updatedState = cloneDeep(this.props.promoBannersEditModal);
		updatedState[key] = value;
		this.props.setPromoBannersEditModal(updatedState);
	};

	render() {
		const { promoBannersEditModal, setPromoBannersEditModal } = this.props;
		const { showDeleteModal, isDeleting } = this.state;
		const deleteName = promoBannersEditModal.oldName;
		return (
			<>
				<Modal
					visible={promoBannersEditModal.show}
					onDismiss={this.closeEditModal}
					header="Edit promo banner"
					children={
						<SpaceBetween direction="vertical" size="m">
							<Box variant="span">Name Type</Box>
							<Select
								filteringType="auto"
								placeholder="Select name type"
								selectedOption={promoBannersEditModal.nameType}
								onChange={(option) =>
									this.updateParam("nameType", option.detail.selectedOption)
								}
								options={promoBannersEditModal.currentOption.nameType}
							/>
							<Box variant="span">Name</Box>
							<Input
								name="Title"
								autoComplete="off"
								inputMode="text"
								type="text"
								disableBrowserAutocorrect={true}
								placeholder="Name"
								value={promoBannersEditModal.name}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										name: event.detail.value,
									})
								}
							/>
							<Box variant="span">Description Type</Box>
							<Select
								filteringType="auto"
								placeholder="Select title type"
								selectedOption={promoBannersEditModal.descriptionType}
								onChange={(option) =>
									this.updateParam("descriptionType", option.detail.selectedOption)
								}
								options={promoBannersEditModal.currentOption.descriptionType}
							/>
							<Box variant="span">Description Text</Box>
							<Input
								name="Title"
								autoComplete="off"
								inputMode="text"
								type="text"
								disableBrowserAutocorrect={true}
								placeholder="Description text"
								value={promoBannersEditModal.description}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										description: event.detail.value,
									})
								}
							/>
							<Box variant="span">Description prefix</Box>
							<Input
								name="DescriptionPrefix"
								autoComplete="off"
								inputMode="text"
								type="text"
								disableBrowserAutocorrect={true}
								placeholder="Description prefox"
								value={promoBannersEditModal.descriptionPrefix}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										descriptionPrefix: event.detail.value,
									})
								}
							/>
							<Box variant="span">Image</Box>
							<input
								type="file"
								accept="image/jpg"
								onChange={(event) => {
									const file = event.target.files[0];
									if (file) {
										if (!isValidBannerFileSize(file)) {
											this.props.Interface.addNoty("Error", `Image size must not exceed ${MAX_BANNER_BYTES / 1024 / 1024} MB`);
											event.target.value = "";

											return;
										}

										const reader = new FileReader();
										reader.onload = (event) => {
											const result = event.target.result;
											this.updateParam("image", result);
										};
										reader.readAsDataURL(file);
									} else {
										this.props.Interface.addNoty("Error", "Please, select a valid image file");
									}
								}}
							/>
							<Box variant="span">GameID</Box>
							<Input
								name="Title"
								autoComplete="off"
								inputMode="number"
								type="number"
								disableBrowserAutocorrect={true}
								placeholder="GameID"
								value={promoBannersEditModal.gameID}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										gameID: event.detail.value,
									})
								}
							/>
							<Box variant="span">Limit</Box>
							<Input
								name="Title"
								autoComplete="off"
								inputMode="number"
								type="number"
								disableBrowserAutocorrect={true}
								placeholder="Limit"
								value={promoBannersEditModal.limit}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										limit: event.detail.value,
									})
								}
							/>
							<Box variant="span">Min deposit</Box>
							<Input
								name="Title"
								autoComplete="off"
								inputMode="number"
								type="number"
								disableBrowserAutocorrect={true}
								placeholder="Min deposit"
								value={promoBannersEditModal.minDeposit}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										minDeposit: event.detail.value,
									})
								}
							/>
							<Box variant="span">Wager</Box>
							<Input
								name="Title"
								autoComplete="off"
								inputMode="number"
								type="number"
								disableBrowserAutocorrect={true}
								placeholder="Wager"
								value={promoBannersEditModal.wager}
								onChange={(event) =>
									setPromoBannersEditModal({
										...promoBannersEditModal,
										wager: event.detail.value,
									})
								}
							/>
							<Box variant="span">Date</Box>
							<DateRangePicker
								onChange={({ detail }) => {
									setPromoBannersEditModal({
										...promoBannersEditModal,
										from: detail.value.startDate.split("+")[0],
										to: detail.value.endDate.split("+")[0],
										type: detail.value.type
									});
								}}
								value={{
									startDate: promoBannersEditModal.from,
									endDate: promoBannersEditModal.to,
									type: "absolute",
								}}
								relativeOptions={[]}
								isValidRange={range => {
									if (range.type === "absolute") {
										const [
											startDateWithoutTime
										] = range.startDate.split("T");
										const [
											endDateWithoutTime
										] = range.endDate.split("T");
										if (
											!startDateWithoutTime ||
											!endDateWithoutTime
										) {
											return {
												valid: false,
												errorMessage:
													"The selected date range is incomplete. Select a start and end date for the date range."
											};
										}
										if (
											new Date(range.startDate) -
											new Date(range.endDate) >
											0
										) {
											return {
												valid: false,
												errorMessage:
													"The selected date range is invalid. The start date must be before the end date."
											};
										}
									} else {
										return { valid: false}
									}
								}}
								i18nStrings={{
									todayAriaLabel: "Today",
									nextMonthAriaLabel: "Next month",
									previousMonthAriaLabel: "Previous month",
									customRelativeRangeDurationLabel: "Duration",
									customRelativeRangeDurationPlaceholder: "Enter duration",
									customRelativeRangeOptionLabel: "Custom range",
									customRelativeRangeOptionDescription: "Define a custom range in the past",
									customRelativeRangeUnitLabel: "Unit of time",
									formatRelativeRange: ({ amount, unit, startDate, endDate }) => {
										const start = new Date(startDate);
										const end = new Date(endDate);

										const locale = 'en-GB';
										const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
										const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };

										const formattedStart = start.toLocaleDateString(locale, dateOptions) + ' ' + start.toLocaleTimeString(locale, timeOptions);
										const formattedEnd = end.toLocaleDateString(locale, dateOptions) + ' ' + end.toLocaleTimeString(locale, timeOptions);

										return `${formattedStart} - ${formattedEnd}`;
									},
									formatUnit: (unit, amount) => `${unit}${amount > 1 ? 's' : ''}`,
									dateTimeConstraintText: "Date and time must be within the selected range.",
									renderSelectedAbsoluteRangeAriaLive: (startDate, endDate) => `Selected from ${startDate} to ${endDate}`,
									labelRelativeRange: "Relative range",
									labelAbsoluteRange: "Absolute range",
									dateTimePickerAriaLabel: "Date and time picker",
									dateTimePickerLabel: "Date and Time",
									clearButtonAriaLabel: "Clear date range",
									relativeModeTitle: "Relative mode",
									absoluteModeTitle: "Absolute mode",
									cancelButtonLabel: "Cancel",
									applyButtonLabel: "Apply",
								}}
								placeholder="Only from"
							/>
						</SpaceBetween>
					}
					footer={
						<Box float="right">
							<SpaceBetween direction="horizontal" size="m">
								{promoBannersEditModal.oldName ? (
									<Button
										className={[this.props.styles["btnUID"], this.props.styles["blue"]].join(" ")}
										variant="normal"
										onClick={this.openDeleteModal}
										disabled={this.state.loading || isDeleting}
										children="Delete"
									/>
								) : (
									<></>
								)}
								<Button
									variant="normal"
									onClick={this.closeEditModal}
									children="Close"
								/>
								<Button
									variant="primary"
									disabled={this.state.loading || isDeleting}
									onClick={() => this.addBanner()}
									children="Ok"
								/>
							</SpaceBetween>
						</Box>
					}
				/>

				<Modal
					visible={showDeleteModal}
					onDismiss={this.closeDeleteModal}
					header="Confirm Deletion"
					footer={
						<Box float="right">
							<SpaceBetween direction="horizontal" size="xs">
								<Button
									variant="link"
									onClick={this.closeDeleteModal}
									disabled={isDeleting}
									children="Close"
								/>
								<Button
									variant="primary"
									onClick={this.confirmDelete}
									loading={isDeleting}
									disabled={isDeleting}
									children="Apply"
								/>
							</SpaceBetween>
						</Box>
					}
				>
					<SpaceBetween direction="vertical" size="xs">
						<Box variant="p">Are you sure you want to delete this promo banner? This action will delete the saved banner.</Box>
						<Box variant="p">Name: {deleteName ? deleteName.text : ""}</Box>
						<Box variant="p">Type: {deleteName ? deleteName.type : ""}</Box>
					</SpaceBetween>
				</Modal>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promoBannersEditModal = useRecoilValue(promoBannersEditModalStore);
		const setPromoBannersEditModal = useSetRecoilState(promoBannersEditModalStore);
		const promoBanners = useRecoilValue(promoBannersStore);
		const setPromoBanners = useSetRecoilState(promoBannersStore);
		return (
			<Component
				{...props}
				promoBanners={promoBanners}
				setPromoBanners={setPromoBanners}
				setPromoBannersEditModal={setPromoBannersEditModal}
				promoBannersEditModal={promoBannersEditModal}
			/>
		);
	};
}

export default withRecoil(PromoBannersEditModal);
